module.exports = __webpack_public_path__ + "img/home1.ace2e686.png";